<div class="video-player" [class.responsive]="responsive">
    <div [id]="playerId"></div>
</div>
